import Header from './Header';
import SessionDropdown from './SessionDropdown';
import Review from './Review';
import HomeReviews from './HomeReviews';
import NewsletterModal from './NewsletterModal';


const components = {
  Header,
  SessionDropdown,
  Review,
  HomeReviews,
  NewsletterModal
}

export default components;
